<template>
  <div class="pt-150 lg:j-pt-140 lg:j-pb-40">
    <div class="px-30 lg:j-p-0 lg:j-w-1100 lg:j-h-187 mx-auto flex-center flex-col relative">
        <h2 class="slogon-title" v-html="t('member_index.redeem_points.title')"></h2>
        <p v-if="props.isLogin" class="slogon-points">
          {{ t('member_index.redeem_points.pointTips', [pointAmount]) }}
        </p>
        <img
          class="lazyload hidden lg:(block j-w-34 j-h-54 absolute left-0 top-0)"
          data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/1_d4621f27-b474-43ea-902e-f00f790cf09b.png?v=1670915016"
          alt=""
        >
        <img
          class="lazyload hidden lg:(block j-w-46 j-h-66 absolute right-0 bottom-0)"
          data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/2_55109115-cdac-4786-9031-e7168f04d355.png?v=1670915016"
          alt=""
        >
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n()

const props = defineProps({
  isLogin: Boolean,
  pointAmount: Number|String,
})
</script>

<style scoped>
.slogon-title {
  @apply
    w-full text-left text-52 leading-64 px-40 lg:px-0
    lg:text-center lg:j-text-48 lg:j-leading-56 font-semibold text-sub
}
.slogon-points {
  @apply
    w-full text-left text-32 leading-32 mt-40 px-40 lg:px-0 text-#808080 font-semibold
    lg:text-center lg:j-text-22 lg:j-leading-22 lg:j-mt-33
}
</style>
